import React from 'react'
import { useNavigate } from 'react-router-dom'
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded'
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded'
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded'
import FolderRoundedIcon from '@mui/icons-material/FolderRounded'
import MeetingRoomRoundedIcon from '@mui/icons-material/MeetingRoomRounded'
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded'
import JumpToPicker from 'features/dashboard/sections/JumpToPicker'
import { ENTITY_COLORS } from 'constants/entityColors'

const BP_SECTIONS = [
  { key: 'compliance', label: 'Compliance tracker', sub: 'Obligations, evidence & score',    Icon: FactCheckRoundedIcon,          tint: '#15803d' },
  { key: 'tasks',      label: 'Tasks',              sub: 'Tasks for this building',           Icon: AssignmentTurnedInRoundedIcon, tint: '#7C5FE0' },
  { key: 'dashboard',  label: 'Dashboard',          sub: 'This building on your dashboard',   Icon: SpaceDashboardRoundedIcon,     tint: '#33becc' },
  { key: 'details',    label: 'Details',            sub: 'Building overview & information',    Icon: HomeWorkRoundedIcon,           tint: '#D24724' },
  { key: 'files',      label: 'Documents',              sub: 'Documents on this building',        Icon: FolderRoundedIcon,             tint: '#0e7490' },
  { key: 'units',      label: 'Units',              sub: 'Unit Passports in this building',   Icon: MeetingRoomRoundedIcon,        tint: ENTITY_COLORS.unit },
]

const GlobalJumpTo = ({ open, onClose }) => {
  const navigate = useNavigate()

  const go = target => {
    if (!target?.type || !target?.id) return

    if (target.type === 'bp') {
      const id = target.id
      switch (target.section) {
        case 'compliance': navigate(`/bp-list/${id}/compliance`); break
        case 'tasks':      navigate(`/tasks?bpId=${id}`); break
        case 'dashboard':  navigate(`/dashboard?altitude=bp&entityId=${id}`); break
        case 'details':    navigate(`/bp-list/${id}/wiki`); break
        case 'files':      navigate(`/bp-list/${id}/files`); break
        case 'units':      navigate(`/bp-list/${id}/units`); break
        default:           navigate(`/bp-list/${id}`)
      }
      return
    }

    if (target.type === 'unit' && target.parentId) {
      navigate(`/bp-list/${target.parentId}/units/${target.id}`)
      return
    }

    if (target.type === 'estate') {
      navigate(`/estates/${target.id}`)
      return
    }

    if (target.type === 'portfolio') {
      navigate(`/portfolios/${target.id}`)
    }
  }

  return (
    <JumpToPicker
      open={open}
      onClose={onClose}
      onSelect={go}
      bpSections={BP_SECTIONS}
    />
  )
}

export default GlobalJumpTo
